var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "profileClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#profileClip)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0ZM22.6663 11.3337C22.6663 15.0156 19.6816 18.0003 15.9997 18.0003C12.3178 18.0003 9.33301 15.0156 9.33301 11.3337C9.33301 7.65176 12.3178 4.66699 15.9997 4.66699C19.6816 4.66699 22.6663 7.65176 22.6663 11.3337ZM3.87988 31.333C3.87988 25.813 9.31988 21.333 15.9999 21.333C22.6799 21.333 28.1199 25.813 28.1199 31.333C28.1199 31.7063 27.8265 31.9997 27.4532 31.9997H4.54655C4.17322 31.9997 3.87988 31.7063 3.87988 31.333Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "currentColor"
  })));
};
export default SvgProfile;